<template>
  <div>
    <jwplayer ref="jwplayer" :options="this.$manager.jwOptions"></jwplayer>
  </div>
</template>

<script>

  import PlayerMixin from '../mixins/PlayerMixin.vue'
  import axios from 'axios'

  export default {

    name: 'VipoPlayer',

    mixins: [PlayerMixin],

    props: {
      videoId: {
        required: false
      },
      collectionId: {
        required: false
      },
      boNr: {
        required: false
      },
      api: {
        required: false,
        default () {
          return 'http://www.rtl2.de/sites/default/modules/rtl2/mediathek/php/get_video_jw.php'
        }
      }
    },

    data () {
      return {
        vipoData: null,
        relatedPlugin: null,
        showRelated: false
      }
    },

    computed: {
        vipo_params () {
            var params = {}

            if(typeof this.boNr !== 'undefined') {
                params.bonr = this.boNr
            }
            else if(typeof this.collectionId !== 'undefined') {
                params.vico_id = this.collectionId
            }

            if(typeof this.videoId !== 'undefined') {
                params.vivi_id = this.videoId
            }
            else if(this.vipoData && typeof this.vipoData.video.vivi_id !== 'undefined' ) {
                params.vivi_id = this.vipoData.video.vivi_id
            }

            return params
        },

        reco_url () {
            return this.settings.vipo.reco + '?' + this.$helpers.getQueryString(this.vipo_params)
        }
    },

    mounted () {

      if(typeof this.boNr === 'undefined' && typeof this.collectionId === 'undefined') {
          this.$events.emit('fatalError', {msg: 'Fehlende Abspielinformationen.'})
      }

      if(this.$route.query.rel) {
          this.showRelated = this.$route.query.rel
      }

      this.loadVipoData()
    },

    methods: {

      /**
       * Metadaten werden von VIPO API geladen
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      loadVipoData () {
        this.$l.log('loading videoId', this.videoId)

        axios.get(this.$settings.vipo.api, {
          params: this.vipo_params
        }).then((response) => {
          this.vipoData = response.data

          // OVERLAY:""
          // POSTROLL:"http://de-ipd.videoplaza.tv/proxy/distributor/v2?rt=vast_2.0&s=rtl2_rtl2/hilf_mir&tt=po&pf=ipd&t=j4%3D2,j5%3D0,j5%3D1,j5%3D2,j5%3D3,html5&rnd=__random-number__"
          // PREROLL:"http://de-ipd.videoplaza.tv/proxy/distributor/v2?rt=vast_2.0&s=rtl2_rtl2/hilf_mir&tt=p&pf=ipd&t=j4%3D2,j5%3D0,j5%3D1,j5%3D2,j5%3D3,html5&rnd=__random-number__"
          // VIAZ_Name:"rtl2.de"
          // beschreibung:"Jule steckt tief in der Patsche. Lars ist weg, sie hat eine Anzeige am Hals und ist völlig verzweifelt. Grade jetzt braucht sie ihre beste Freundin am dringendsten - und auf diese ist auch Verlass!"
          // captions:null
          // duration:"453"
          // image:"http://www.rtl2.de/vipo/img/51524_video-hilf-mir-jung-pleite-verzweifelt-folge-88-08.jpeg_vptn174x97.jpg"
          // link:"/sendung/hilf-mir-jung-pleite-verzweifelt/video/18970-best-of-brautalarm-folge-88/51524-jetzt-kommt-es-schlag-auf-schlag/"
          // poster:"http://www.rtl2.de/vipo/img/51524_video-hilf-mir-jung-pleite-verzweifelt-folge-88-08.jpeg_vptn720x405.jpg"
          // streamurl:"rtmp://cp108780.edgefcs.net/ondemand/flv_dach/vipo/hilf-mir-jung-pleite-verzweifelt/PR081226_8_01SU2HJ674T11SV2_8_10370814_10444103_16-9.mp4"
          // streamurl_hls:"http://trans_01_dach-vh.akamaihd.net/i/delivery/34/2a/342aef5c-09ef-4908-9ad7-702ae5874598/PR081226_8_01SU2HJ674T11SV2_8_10370814_10444103_16-9_,1350,2350,3850,250,650,65,1000,k.mp4.csmil/master.m3u8"
          // titel:"Jetzt kommt es Schlag auf Schlag!"
          // vico_id:"18970"
          // vico_mt_titel:"Best of �Brautalarm� (Folge 88)"
          // vifo_name:"Hilf mir! Jung, pleite, verzweifelt..."
          // vivi_id:"51524"
          // vpCategory:"rtl2_rtl2/hilf_mir"

          this.$manager.addItemData({
            source: 'vipo',
            id: this.vipoData.video.vivi_id,
            title: this.vipoData.video.titel,
            description: this.vipoData.video.beschreibung,
            poster: this.vipoData.video.poster,
            format: this.vipoData.video.vifo_name,
            formatId: this.vipoData.video.formatId,
            duration: this.vipoData.video.duration,
            adZone: this.vipoData.video.vpCategory,
            collection: this.vipoData.video.vico_id,
            collectionName: this.vipoData.video.vico_mt_titel,
            permalink: this.vipoData.video.link,
          })


          this.setupVideo()
        }).catch((error) => {
          this.$warn('VIPO API Error', error)
          this.$events.fire('fatalError', {msg: 'Fehler beim laden der Videodaten :('})
        })
      },

      /**
       * JWPlayer Setup
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      setupVideo () {

        var video = this.vipoData.video;

        this.$videoAdSchedule.setup({
          duration: video.duration,
          streamurl: this.$helpers.streamToHttps(video.streamurl_hls),
          zone: video.vpCategory,
          fsk16: video.fsk16 ? 1 : 0
        });

        if(this.$settings.ads && video.vpCategory && !video.NOADS) {

            this.$videoAdSchedule.activate()

            // Settings übernehmen
            this.$l.log('adSchedule setup', this.$videoAdSchedule.adSchedule)
            this.$manager.addOptions('advertising', {
                schedule: this.$videoAdSchedule.adSchedule
            })
        }

        if(this.showRelated) {
            this.$manager.addOptions({
                nextUpDisplay: true,

                related: {
                    file: this.reco_url,
                }
            })
        }

        // Playliste übernehmen
        this.$manager.addPlaylist([{
          title: video.titel,
          description: video.beschreibung,
          image: video.poster,
          sources: [{
            file: this.$helpers.streamToHttps(video.streamurl_hls),
            type: 'hls'
          }]
        }])

        // Setup fertig
        this.$manager.finalizeSetup()
      }


    },


    events: {

        jwRelatedReady() {
          this.relatedPlugin = this.$jwplayer.getPlugin('related');
          var vm = this;

          if(this.relatedPlugin) {
            this.relatedPlugin.on('open', function(obj) {
              vm.$l.log('related opened', obj)
            })
          }
        },

        jwPlaylist(evt) {
            const item = evt.playlist[0]

            if(typeof item.vivi_id !== 'undefined') {
                this.$videoAdSchedule.setup({
                    duration: item.seconds || item.duration,
                    streamurl: this.$helpers.streamToHttps(item.sources[0].file),
                    zone: item.vpCategory
                })

                item.adschedule = this.$videoAdSchedule.adSchedule
                item.schedule = this.$videoAdSchedule.adSchedule
                item.fun = 'huihui hui'
            }
        },

        jwPlaylistItem(evt) {
            this.$l.log('playlist playing vivi_id', evt.item.vivi_id, evt.item)

            if(typeof evt.item.vivi_id !== 'undefined') {

              let itemData = {
                source: 'vipo',
                id: evt.item.vivi_id,
                title: evt.item.title,
                description: evt.item.description,
                poster: evt.item.poster,
                format: evt.item.vifo_name,
                formatId: evt.item.formatId,
                //TODO: in Sekunden umrechnen
                duration: evt.item.seconds || evt.item.duration,
                adZone: evt.item.vpCategory,
                collection: evt.item.vico_id,
                collectionName: evt.item.vico_mt_titel,
                permalink: evt.item.link,
              }

              this.$manager.addItemData(itemData);

              window.parent.postMessage({action: 'newItemData', item: itemData}, '*');
            }

        }

    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Vipo.vue